import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'company_size'

export const dataPointDefinition = {
  retracedId: 'company_size',
  name: 'Company Size',
  description: '',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FROM_0_TO_1',
      text: 'From 0 to 1',
    },
    {
      key: 'FROM_2_TO_10',
      text: 'From 2 to 10',
    },
    {
      key: 'FROM_11_TO_50',
      text: 'From 11 to 50',
    },
    {
      key: 'FROM_51_TO_200',
      text: 'From 51 to 200',
    },
    {
      key: 'FROM_201_TO_500',
      text: 'From 201 to 500',
    },
    {
      key: 'FROM_501_TO_1000',
      text: 'From 501 to 1000',
    },
    {
      key: 'FROM_1001_TO_5000',
      text: 'From 1001 to 5000',
    },
    {
      key: 'FROM_5001_TO_10000',
      text: 'From 5001 to 10000',
    },
    {
      key: 'FROM_10001_TO_INFINITE',
      text: 'From 10001 to infinite',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: [
          'FROM_0_TO_1',
          'FROM_2_TO_10',
          'FROM_11_TO_50',
          'FROM_51_TO_200',
          'FROM_201_TO_500',
          'FROM_501_TO_1000',
          'FROM_1001_TO_5000',
          'FROM_5001_TO_10000',
          'FROM_10001_TO_INFINITE',
        ],
        maxLength: 255,
      },
    },
    required: ['value'],
  },
  externalIds: [],
  sortingId: 301,
  sectionId: '1.1',
  impactArea: 'About',
  impactAreaId: 'ABOUT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
